import { Text } from '@chakra-ui/react';
import cn from 'classnames';
import Link from 'next/link';
import { useParams, useSearchParams } from 'next/navigation';
import React from 'react';

import { ChildFilter, ParentFilter } from '@/types/filters/filters.types';

import styles from './landing-children-list.module.scss';

export const LandingChildrenList: React.FC<{
  activeParent?: ParentFilter;
  activeChild?: ChildFilter;
  getChildLink: (
    parent: ParentFilter,
    child: ChildFilter,
    carType: string,
  ) => string;
  title?: string | React.ReactNode;
  activeChildAs?: any;
}> = ({ activeParent, activeChild, getChildLink, title, activeChildAs }) => {
  const params = useParams();
  const searchParams = useSearchParams();
  const path = params?.carType;
  const type = searchParams.get('type');

  return (
    <div className={styles.childrenList}>
      <div className={styles.parentName}>{title}</div>
      <div className={styles.childrenItems}>
        {activeParent?.children?.map((child) => {
          const isActive = child.id === activeChild?.id;
          const as = isActive && activeChildAs ? 'h1' : undefined;
          const baseHref = getChildLink(activeParent, child, path as string);

          const href =
            type === 'demo'
              ? `${baseHref}?type=demo`
              : baseHref;

          return (
            <span
              className={cn(styles.childrenItem, {
                [styles.childrenItemActive as string]: isActive,
              })}
              key={child.id}
            >
              <Text as={as}>
                <Link href={href}>
                  {child.name}
                </Link>
              </Text>
            </span>
          );
        }) || null}
      </div>
    </div>
  );
};
